export const featureFlags = {
  trackPerformanceExtensively:
    window.location.search.includes("cid=sapientwatchdog") ||
    navigator.userAgent.includes("DHL-Performance-User-Agent"),
};
